import React from 'react';
import PropTypes from 'prop-types';
import history from '../../history';
import { Table, Input, Icon, LocaleProvider, Popconfirm, message } from 'antd';
import ui from '../../lang/ui.json';
import s from './Contacts.css';
import { Link } from 'react-router-dom';
import {fetchDecode} from '../../fetchUtils';
import { withRouter } from 'react-router'

class Contacts extends React.Component {

  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      search: [],
      filterDropdownVisible: false,
      searchText: '',
      filtered: false,
      selectedRowKeys: [],
      showSendMessageButton: false,
      config: require('Config'),
    };
    this.selectRow = this.selectRow.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
  }

  componentDidMount() {
    fetchDecode(this.state.config.serverUrl + `contacts/all`, message)
      .then(jsonContactList => this.setState({ data: jsonContactList, search: jsonContactList }));
  }

  onSearch = (e) => {
    const searchText = e.target.value;
    const reg = new RegExp(searchText, 'gi');
    this.setState({
      searchText: e.target.value,
      filtered: !!searchText,
      search: this.state.data.map((record) => {
        const match = record.name.match(reg);
        if (!match) {
          return null;
        }
        return {
          ...record,
          name: (
            <span>
              {record.name.split(reg).map((text, i) => (
                i > 0 ? [<span className={s.highlight}>{match[0]}</span>, text] : text
              ))}
            </span>
          ),
        };
      }).filter(record => !!record),
    });
  };

  onSearchEnd = () => {
    this.setState({
      filterDropdownVisible: false,
    });
  };

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  deleteFromTable = (row) => {
    const dataSource = this.state.data;
    const index = dataSource.findIndex(data => data.msisdn === row);
    dataSource.splice(index, 1);
    this.setState({ data: dataSource });
  };

  deleteUser = (id) => {
    fetch(this.state.config.serverUrl + `contacts/user/${id}`,
      {
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        }),
        method: 'DELETE'
      },
    ).then((response) => {
      if (response.status === 204) {
        this.successMessage();
        this.deleteFromTable(id);
      } else {
        this.errorMessage(response.statusText);
      }
    });
  };

  selectRow = (record) => {
    const selectedRowKeys = this.state.selectedRowKeys;
    if (selectedRowKeys.indexOf(record.msisdn) >= 0) {
      selectedRowKeys.splice(selectedRowKeys.indexOf(record.msisdn), 1);
    } else {
      selectedRowKeys.push(record.msisdn);
    }
    this.setState({ selectedRowKeys : selectedRowKeys});

    if(selectedRowKeys.length > 0){
      this.setState({showSendMessageButton : true})
    }
    else {
      this.setState({showSendMessageButton : false})
    }
  }

  selectAllRows = (selected, selectedRows, changeRows) => {
    if (selected) {
      // If all rows are selected, update the selectedRowKeys state with all MSISDNs
      const allKeys = this.state.data.map(record => record.msisdn);
      this.setState({ selectedRowKeys: allKeys, showSendMessageButton: true });
    } else {
      // If not all rows are selected, update the selectedRowKeys state with an empty array
      this.setState({ selectedRowKeys: [], showSendMessageButton: false });
    }
  };

  sendMessage = () => {
      history.push({
          pathname: '/message',
          state: {numbers: this.state.selectedRowKeys}
      });
  }


  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onSelect: this.selectRow,
      onSelectAll: this.selectAllRows,
    };
    const columns = [{
      title: this.props.locale.tableMSISDN,
      dataIndex: 'msisdn',
      key: 'msisdn',
      width: 250,
      sorter: (a, b) => {
        if (a.msisdn < b.msisdn) return -1;
        if (a.msisdn > b.msisdn) return 1;
        return 0;
      },
      render: text => <Link to={`/contacts/${text}`}>{text}</Link>,
    }, {
      title: this.props.locale.tableName,
      dataIndex: 'name',
      key: 'name',
      filterDropdown: (
        <div className={s.filter}>
          <Input
            ref={ele => (this.searchInput = ele)}
            placeholder={this.props.locale.search}
            value={this.state.searchText}
            onChange={this.onSearch}
            onPressEnter={this.onSearchEnd}
          />
        </div>
      ),
      filterIcon: <Icon type="search" style={{ color: this.state.filtered ? '#00aef3' : '#aaa' }} />,
      filterDropdownVisible: this.state.filterDropdownVisible,
      onFilterDropdownVisibleChange: (visible) => {
        this.setState({
          filterDropdownVisible: visible,
        }, () => this.searchInput.focus());
      },
      sorter: (a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      },
    }, {
      title: '',
      key: 'delete',
      dataIndex: 'msisdn',
      width: 30,
      render: id => (
        <Popconfirm
          title={this.props.locale.confirm}
          onConfirm={() => this.deleteUser(id)}
        >
          <Icon type="close-circle-o" className={s.delete} />
        </Popconfirm>
      ),
    }];
    return (
      <LocaleProvider locale={ui}>
        <div className={s.root}>
          <div className={s.headline}>
            <h1>{this.props.locale.title}</h1>
            <div className={s.headline_cont}>
              <Link to="/add_new_contact" className={s.headline__btn}>
                <Icon className={s.headline__icon} type="plus-circle-o" />
                {this.props.locale.button}
              </Link>
            </div>
          </div>
          <Table
            className={s.table}
            columns={columns}
            dataSource={this.state.search}
            rowKey={r => r.msisdn}
            rowSelection={rowSelection}
            onRowClick={(record) =>   this.selectRow(record) }
          />
          <div className={s.headline_cont} style={{visibility: this.state.showSendMessageButton ? "visible" : "hidden"}}>
            <button className={s.headline__btn} onClick={this.sendMessage}>
              <Icon className={s.headline__icon} type="plus-circle-o" />
              {this.props.locale.sendMessage}
            </button>
          </div>
        </div>
      </LocaleProvider>
    );
  }
}

export default (Contacts);




// WEBPACK FOOTER //
// ./src/routes/contacts/Contacts.js